import { Company } from "../../enums/Company";

export class ConfirmPageRequest {
    Id! : string;
    Company!: Company
}
